export default __webpack_public_path__ + "static/media/sublime.f9991326.png";